import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  stack: {
    marginTop: 16,
    justifyContent: 'flex-end',
  },
  stackSpace: {
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${Colors.Grey3}`,
  },
}));

export default useStyles;
